import React from 'react';

interface Props {

}

const LoggedOut : React.FC<Props> = () => {
    return <>Sie sind zurzeit nicht im Kundenpostfach angemeldet.</>
}

export default LoggedOut;